import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { FiMenu, FiX } from "react-icons/fi";
import { 
  FiDollarSign, 
  FiShield, 
  FiZap, 
  FiGift, 
  FiMail, 
  FiHeadphones 
} from "react-icons/fi";
const slides = [
  {
    id: 1,
    title: "USPS Promotions, Zero Hassle",
    description: "Apply instantly. No Business Customer Gateway required.",
    primaryBtn: { text: "Get Started", link: "/promotions" },
    secondaryBtn: { text: "Learn More", link: "" }
  },
  {
    id: 2,
    title: "Informed Delivery – Launch Fast",
    description: "Build & submit campaigns directly here. Skip the USPS Gateway.",
    primaryBtn: { text: "Start Campaign", link: "/informed-delivery" },
    secondaryBtn: { text: "Learn More", link: "" }
  },
  {
    id: 3,
    title: "Postage Optimization by POStratics",
    description: "Cut mailing costs fast – expert consulting, no guesswork.",
    primaryBtn: { text: "Schedule A Consult", link: "/audit" },
    secondaryBtn: { text: "Learn More", link: "" }
  }
];

// Duplicate first slide for perfect infinite loop
const carouselSlides = [...slides, slides[0]];

export default function App() {
  const [index, setIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [heroHeight, setHeroHeight] = useState('30vh');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const timeoutRef = useRef(null);

  
  // Responsive height
  useEffect(() => {
    const update = () => setHeroHeight(window.innerWidth <= 768 ? '50vh' : '30vh');
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);


  // FINAL: Nav → gradient + guaranteed white logo & text when scrolled
  useEffect(() => {
    const nav = document.querySelector('nav');
    const logo = document.querySelector('.logo');
    const desktopLinks = document.querySelectorAll('.desktop-menu a');
    const mobileBtn = document.querySelector('.mobile-menu-btn');
    const getStartedBtn = document.querySelector('.desktop-menu button');
    const mobileMenuLinks = document.querySelectorAll('.mobile-menu a');
    const mobileMenuBtn = document.querySelector('.mobile-menu button');

    const handleScroll = () => {
      const heroHeight = window.innerWidth <= 768 ? window.innerHeight * 0.5 : window.innerHeight * 0.3;
      const triggerPoint = heroHeight - 64;

      if (window.scrollY >= triggerPoint) {
        // ─── Scrolled: Gradient nav + WHITE text ───
        nav.style.background = 'linear-gradient(135deg, #165284, #0ea5e9)';
        nav.style.backdropFilter = 'blur(8px)';
        nav.style.boxShadow = '0 4px 20px rgba(0,0,0,0.25)';

        // Force white with !important via style attribute
        logo.style.cssText = 'color: white !important; font-weight: 900 !important;';
        
        desktopLinks.forEach(link => link.style.color = 'white');
        mobileBtn.style.color = 'white';
        mobileMenuLinks.forEach(link => link.style.color = 'white');

        if (getStartedBtn) {
          getStartedBtn.style.background = 'white';
          getStartedBtn.style.color = '#165284';
        }
        if (mobileMenuBtn) {
          mobileMenuBtn.style.background = 'white';
          mobileMenuBtn.style.color = '#165284';
        }
      } else {
        // ─── Top of page: Original style ───
        nav.style.background = 'rgba(255, 255, 255, 0.95)';
        nav.style.backdropFilter = 'blur(12px)';
        nav.style.boxShadow = '0 1px 10px rgba(0,0,0,0.08)';

        logo.style.cssText = ''; // reset to CSS default
        desktopLinks.forEach(link => link.style.color = '');
        mobileBtn.style.color = '';
        mobileMenuLinks.forEach(link => link.style.color = '');

        if (getStartedBtn) {
          getStartedBtn.style.background = '';
          getStartedBtn.style.color = '';
        }
        if (mobileMenuBtn) {
          mobileMenuBtn.style.background = '';
          mobileMenuBtn.style.color = '';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);




  
  // Auto-play with perfect infinite loop
  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(goNext, 5000);
    return resetTimeout;
  }, [index]);

  const goNext = () => {
    if (index === slides.length) {
      setIsTransitioning(false);
      setIndex(0);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setIsTransitioning(true));
      });
    } else {
      setIndex(index + 1);
    }
  };


  
  const goPrev = () => {
    resetTimeout();
    setIndex(index === 0 ? slides.length - 1 : index - 1);
  };

  // Touch swipe
  const [touchStart, setTouchStart] = useState(null);
  const onTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const onTouchEnd = (e) => {
    if (!touchStart) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? goNext() : goPrev();
    }
    setTouchStart(null);
  };

  return (
    <>
      {/* Navigation - exactly as before */}
      <nav>
        <div className="nav-container">
          <div className="logo">Lightning Presort</div>
          <div className="desktop-menu">
            <a href="#">Home</a>
            <a href="#features">Features</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
            <button>Get Started</button>
          </div>
  <div
  className="mobile-menu-btn"
  onClick={() => setIsMenuOpen(!isMenuOpen)}
>
  {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
</div>
        </div>
        {isMenuOpen && (
          <div className="mobile-menu">
            <a href="#">Home</a>
            <a href="#features">Features</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
            <button style={{width:'100%', marginTop:'0.5rem'}}>Get Started</button>
          </div>
        )}
      </nav>


      {/* HERO - Perfect Infinite Carousel + PERFECT CENTER ALIGNMENT */}
      <section className="hero" style={{  position: 'relative', overflow: 'hidden', marginTop: '64px' }}>
        {/* Fixed background */}
        <div style={{
          position: 'absolute', inset: 0,
         background: 'linear-gradient(135deg, #5b21b6, #0ea5e9)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }} />
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)' }} />

        {/* Sliding text - now perfectly centered */}
        {/* Sliding text */}
        {/* Sliding content INCLUDING buttons */}
<div
  style={{
    position: 'absolute',
    inset: 0,
    display: 'flex',
    transform: `translateX(-${index * 100}%)`,
    transition: isTransitioning ? 'transform 0.7s ease-in-out' : 'none',
  }}
  onTouchStart={onTouchStart}
  onTouchEnd={onTouchEnd}
>
  {carouselSlides.map((slide, i) => (
   <div
  key={i}
  style={{
    minWidth: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',     // This + flex:1 above = magic
    alignItems: 'center',
    textAlign: 'center',
    color: 'white',
    padding: '2rem',
    gap: '3rem',                  // Increased slightly for breathing room
    boxSizing: 'border-box',
  }}
>
      {/* Title & Description */}
     {/* Title & Description - now perfectly stable */}
<div style={{
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '900px',
  padding: '0 1rem',
}}>
  <h1 style={{
    fontSize: 'clamp(.9rem, 6vw, 2.2rem)',
    fontWeight: 900,
    margin: '0 0 1.2rem 0',
    lineHeight: '1.15',
    letterSpacing: '-0.5px',
  }}>
    {slide.title}
  </h1>
  <p style={{
    fontSize: 'clamp(1.15rem, 4vw, 1.7rem)',
    opacity: 0.96,
    margin: 0,
    maxWidth: '800px',
    lineHeight: '1.55',
  }}>
    {slide.description}
  </p>
</div>

      {/* Unique Buttons per Slide */}
      <div style={{
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '640px',
      }}>
        <a href={slide.primaryBtn.link} className="btn-primary">
          {slide.primaryBtn.text}
        </a>
        <a href={slide.secondaryBtn.link} className="btn-secondary">
          {slide.secondaryBtn.text}
        </a>
      </div>
    </div>
  ))}
</div>
      </section>

{/* Features Section - 6 Cards with Perfect Icons */}
<section id="features" className="features">
  <h2 style={{fontSize:'clamp(.9rem, 8vw, 2.5rem)'}}>Why Choose Lightning Presort</h2>
  <p style={{
    maxWidth: '800px',
    margin: '0 auto 3rem',
   fontSize:'clamp(.8rem, 6vw, 1.5rem)',
    color: '#6b7280',
    lineHeight: '1.6'
  }}>
    We capture the value most organizations leave on the table — turning overlooked postal strategies into measurable savings and growth.
  </p>

  <div className="feature-grid" style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '2.5rem',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 1rem'
  }}>
    {/* 1. Cost Optimized Presorting */}
    <div className="feature-card">
      <div className="icon-circle"><FiDollarSign size={32} /></div>
      <h3>Cost Optimized Presorting</h3>
      <p>Maximize postage savings with intelligent, data-driven presort algorithms that qualify for the deepest USPS discounts available.</p>
    </div>

    {/* 2. Secure Processing */}
    <div className="feature-card">
      <div className="icon-circle"><FiShield size={32} /></div>
      <h3>Secure Processing</h3>
      <p>Your data never leaves our encrypted platform. Privacy-first by design — fully compliant processing with zero third-party sharing.</p>
    </div>

    {/* 3. Streamlined Mail List Processing */}
    <div className="feature-card">
      <div className="icon-circle"><FiZap size={32} /></div>
      <h3>Streamlined Mail List Processing</h3>
      <p>Upload once, presort instantly. Advanced NCOA, CASS certification, and deduplication — all automated with 99.9% accuracy.</p>
    </div>

    {/* 4. One-Stop USPS Promotions */}
    <div className="feature-card">
      <div className="icon-circle"><FiGift size={32} /></div>
      <h3>One-Stop USPS Promotions</h3>
      <p>Apply and manage every active USPS promotion directly in-platform — no BCG login, no paperwork, instant eligibility confirmation.</p>
    </div>

    {/* 5. Informed Delivery Made Easy */}
    <div className="feature-card">
      <div className="icon-circle"><FiMail size={32} /></div>
      <h3>Informed Delivery Made Easy</h3>
      <p>Design, preview, and launch Informed Delivery campaigns in minutes. Full creative tools and direct submission — no gateway required.</p>
    </div>

    {/* 6. Expert Support Every Step */}
    <div className="feature-card">
      <div className="icon-circle"><FiHeadphones size={32} /></div>
      <h3>Expert Support Every Step</h3>
      <p>Dedicated postal consultants on standby. From strategy to execution — get answers fast, any time you need them.</p>
    </div>
  </div>
</section>
      
 {/* PLANS */}



{/* Pricing Plans – 100% Uniform Cards + Perfect 4 or 2×2 Layout */}
<section style={{ padding: '1rem 1rem', background: '#f8fafc',borderTop:'1px solid lightgray' }}>
  <div style={{ maxWidth: '1600px', margin: '0 auto', textAlign: 'center' }}>
    <h2 style={{
      fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
      fontWeight: 800,
      marginBottom: '0.5rem',
      color: '#1e293b'
    }}>
      Our Pricing Plans
    </h2>
    <p style={{
      fontSize: '1.25rem',
      color: '#64748b',
      maxWidth: '720px',
      margin: '0 auto 4rem'
    }}>
      Choose the perfect plan for your mailing volume and needs.
    </p>

    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '2rem',
      justifyContent: 'center',
      margin: '0 auto'
    }}>
      {/* CARD WRAPPER – forces correct breaking */}
      {[
        { plan: 'Basic', color: '#3b82f6', price: 'Per use', features: ['$50 per Presort', 'USPS Promotions Portal – $99 for 30 days', 'Mail Tracking Included', 'Email & Chat support'], link: '/signup' },
        { plan: 'Pro', color: '#10b981', price: '$2400', popular: true, features: ['Up to 100 Presorts per month', 'USPS Promotions Portal Access', 'Discounted Informed Delivery', 'Free Mail Tracking', 'Priority email, Chat & phone support'], link: '/signup/pro' },
        { plan: 'Enterprise', color: '#8b5cf6', price: '$4800', features: ['Up to 250 Presorts per Month', 'USPS Promotions Portal Access', 'Unlimited Informed Delivery Campaigns', '1-on-1 Promotions Check Ups', 'Priority email & phone support', 'Dedicated account concierge'], link: '/contact' },
        { plan: 'Custom', color: '#fbbf24', price: "Let's Talk", dark: true, features: ['Unlimited Presorts', 'Custom API & Integrations', 'White-label Options', 'Volume-based Pricing', 'Dedicated Success Manager', 'Custom Features & SLAs'], link: '/contact', buttonText: 'Book a Call' }
      ].map((card, i) => (
        <div
          key={i}
          style={{
            flex: '0 1 340px',
            maxWidth: '380px',
            // Force 2×2 when 4 don't fit
            '@media (max-width: 1480px)': {
              flex: '0 1 calc(50% - 1rem)',
              maxWidth: 'calc(50% - 1rem)'
            },
            '@media (max-width: 768px)': {
              flex: '1 1 100%',
              maxWidth: '100%'
            }
          }}
        >
          {/* UNIFORM CARD – same structure for ALL */}
          <div style={{
            background: card.dark ? 'linear-gradient(135deg, #165284 0%, #0ea5e9 100%)' : 'white',
            color: card.dark ? 'white' : '#1e293b',
            borderRadius: '1rem',
            padding: '2.5rem 2rem',
            height: '100%',
            boxShadow: card.popular ? '0 20px 40px rgba(0,0,0,0.12)' : '0 10px 25px rgba(0,0,0,0.08)',
            border: card.popular ? '2px solid #10b981' : card.dark ? 'none' : '1px solid #e2e8f0',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
            {/* Badge – now inside padding, doesn't affect layout */}
            {card.popular && (
              <div style={{
                position: 'absolute',
                top: '-3px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#10b981',
                color: 'white',
                fontSize: '0.875rem',
                fontWeight: 700,
                padding: '0.5rem 1.2rem',
                borderRadius: '0 0 1rem 1rem',
                zIndex: 10
              }}>
                MOST POPULAR
              </div>
            )}
            {card.dark && <div style={{ position: 'absolute', top: 0, left: 0, right: 0, background: 'rgba(251,191,36,0.2)', height: '6px' }}></div>}

            {/* Title */}
            <h3 style={{
              fontSize: '1.8rem',
              fontWeight: 800,
              margin: '1.5rem 0 0.5rem',
              color: card.dark ? '#fbbf24' : card.color,
              textAlign: 'center'
            }}>
              {card.plan}
            </h3>

            {/* Price */}
            <p style={{
              fontSize: card.dark ? '2.6rem' : '2.8rem',
              fontWeight: 900,
              margin: '0 0 2rem',
              textAlign: 'center',
              letterSpacing: card.dark ? '-1px' : '-0.5px'
            }}>
              {card.price}
            </p>

            {/* Features */}
            <ul style={{
              flex: 1,
              textAlign: 'left',
              margin: '0 0 2rem',
              paddingLeft: '1.5rem',
              lineHeight: '2.1',
              fontSize: '1rem',
              opacity: card.dark ? 0.95 : 0.85
            }}>
              {card.features.map((f, idx) => (
                <li key={idx} dangerouslySetInnerHTML={{ __html: f.replace(/\$(.+?)\$/g, '<strong>$$$1$$</strong>') }} />
              ))}
            </ul>

            {/* Button – ALWAYS in the same place */}
            <a
              href={card.link}
              style={{
                marginTop: 'auto',
                display: 'block',
                background: card.dark ? '#fbbf24' : card.color,
                color: card.dark ? '#1e293b' : 'white',
                padding: '1rem 1.5rem',
                borderRadius: '9999px',
                fontWeight: 700,
                fontSize: '1.1rem',
                textAlign: 'center',
                textDecoration: 'none',
                boxShadow: card.dark ? '0 8px 25px rgba(251,191,36,0.4)' : 'none',
                transition: 'all 0.2s'
              }}
            >
              {card.buttonText || 'Choose Plan'}
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>




      {/* Footer - exactly as before */}
      <footer id="contact">
        <div className="footer-grid">
          <div>
            <h3 style={{fontSize:'1.5rem'}}>Lightning Presort<br /> <span style={{fontSize:'1rem'}}> By POStratics</span></h3>
            <p style={{fontWeight:'bold'}}>We Make the USPS Pay for Itself.</p>
          </div>
          <div>
            <h4>Quick Links</h4>
            <a href="#">About</a><br/>
            <a href="#">Services</a><br/>
            <a href="#">Contact</a>
          </div>
          <div>
            <h4>Contact Info</h4>
            <p>sales@lightningpresort.com</p>
            <p>Phone +1 (727) 687-9169</p>
            <p>St. Pete FL, USA</p>
          </div>
        </div>
        <div style={{textAlign:'center', marginTop:'3rem', paddingTop:'2rem', borderTop:'1px solid #374151', color:'#9ca3af'}}>
          © {new Date().getFullYear()} POStratics.   © {new Date().getFullYear()} Lightningpresort. All rights reserved.
        </div>
      </footer>
    </>
  );
}
